import { useCan } from '@refinedev/core';

const SHOW_ONLY = 'You can only view Live Ops (show-only access, or the module is read-only).';

/**
 * Whether this admin may change Live Ops data. Controls that change anything
 * are disabled with `deniedTitle` as their tooltip. Undefined while the check
 * runs is not a denial.
 */
export function useLiveopsChange(): { canChange: boolean; deniedTitle: string | undefined } {
  const { data } = useCan({ resource: 'liveops', action: 'create' });
  const canChange = data?.can !== false;
  return { canChange, deniedTitle: canChange ? undefined : SHOW_ONLY };
}
